import classnames from 'classnames';
import {Button, ButtonColor, ButtonSize, ButtonType} from 'components/atoms/LinksAndButtons/Button';
import {Container} from 'components/atoms/Layout/Container';

import {MainGrid} from 'components/atoms/Layout/MainGrid';
import {CopyButton} from 'components/organisms/GeneralComponents/ContentArea/_copyButton';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {FormattedMessage} from 'react-intl';


import BlockFactory from 'features/blocks/block-factory';

import {IContentBlock} from 'features/blocks/types';

import './style.scss';

interface Props {
    id: string;
    blocks: IContentBlock<unknown>[];
    hasGrid?: boolean;
    fullWidth?: boolean;
    className?: string;
    foldable?: boolean;
    foldAt?: number;
    useBellowFoldSensor?: boolean;
    extraProperties?: Record<string, unknown>;
    compact?: boolean;
    hideCopyButton?: boolean;
}

export const ContentArea: React.FunctionComponent<Props> = (props) => {

    const getBlocks = () => {
        if(props.foldable && props.foldAt) {
            return props.blocks.slice(0, props.foldAt);
        }

        return props.blocks;
    };

    const [folded, setFolded] = useState<boolean>(props.foldable && props.foldAt && props.blocks.length > props.foldAt? true : false);
    const [blocks, setBlocks] = useState<IContentBlock<unknown>[]>(getBlocks());

    useEffect(() => {
        setBlocks(getBlocks());
    }, [props.blocks]);

    const openFold = () => {
        setFolded(false);
        setBlocks(props.blocks);
    };

    const getBlock = (componentName: string) => {
        return BlockFactory(componentName);
    };

    const renderContent = (content: React.ReactNode) => {

        if(props.hasGrid) {
            return (
                <MainGrid fullwidth={props.fullWidth}>
                    {content}
                </MainGrid>
            );
        }

        return content;
    };

    const areaClasses = classnames('content-area', props.className, {
        'content-area--compact': props.compact,
    });

    return (
        <div className={areaClasses}>
            {renderContent((
                blocks && blocks.map((block, index) => {
                    const BlockComponent = getBlock(block.component);


                    if(typeof BlockComponent === 'undefined') {
                        console.error('Block does not exist', block.component);
                        return null;
                    }

                    let data = block.data as Record<string, unknown>;

                    if(props.extraProperties) {
                        data = {
                            ...data,
                            ...props.extraProperties,
                        }
                    }

                    const id = `block-${block.contentId}`;
                    const blockKey = `block-${block.contentId}-${index}`;

                    return (
                        <React.Fragment key={blockKey}>

                                {!props.hideCopyButton && <CopyButton id={id} />}

                                <BlockComponent
                                    component={block.component}
                                    renderStyle={block.renderStyle}
                                    data={data}
                                    index={index}
                                    id={id}
                                />

                        </React.Fragment>

                    );
                })
            ))}


            {(folded && (props.foldAt && props.blocks && props.blocks.length > props.foldAt)) &&
                <Container centered>
                    <Button 
                        className="content-area__fold-button" 
                        onClick={openFold} 
                        buttonColor={ButtonColor.DEFAULT} 
                        buttonSize={ButtonSize.DEFAULT} 
                        buttonType={ButtonType.DEFAULT} 
                    >
                        <FormattedMessage id='jm.components.ContentArea.showMore'/>
                    </Button>
                </Container>
            }
        </div>
    )
};

